jQuery(function ($) {
  // handle clicking the magnifying glass icon in the header
  $('#searchform .header-search__button').click(function (e) {
    // prevent default behaviour and prevent event propagation causing this function to trigger twice when clicking the nested inner element
    e.preventDefault();
    e.stopPropagation();
    var inputContainer = $('#searchform .header-search__input-container');
    var searchButton = $('#searchform .header-search__button');
    var searchInput = $('#searchform .header-search__input-field');
    // If search bar was previously closed, immediately focus the input field so the user can type into it
    if (!inputContainer.hasClass('is-open')) {
      searchInput.focus();
    } else {
      // if search is open and has a non-empty value, submit the form and run the search
      if (!!searchInput.val().trim()) {
        $('#searchform').submit();
      }
    }
    // Toggle the classes to trigger the animation of opening the search bar
    inputContainer.toggleClass('is-open');
    searchButton.toggleClass('is-open');
  });
  // When clicking off of the header search input, remove the classes and minimize the search bar
  // $("#searchform .header-search__input-field").blur(function (e) {
  //     e.preventDefault();
  //     e.stopPropagation();
  //     $("#searchform .header-search__input-container").removeClass("is-open");
  //     $("#searchform .header-search__button").removeClass("is-open");
  // });
  $('.js-close').click(function () {
    $($(this).data('closethis')).slideUp(200);
  });
  $('.js-open').click(function () {
    $($(this).data('openthis')).slideDown(200);
  });

  $('.js-toggle').click(function () {
    $($(this).data('openthis')).slideToggle(200);
  });

  $('.js-togglenext').click(function () {
    $(this).next($(this).data('togglenext')).slideToggle(100);
    $(this).toggleClass('active');
  });

  // Mobile menu
  $('#mbl-nav .menu>.menu-item-has-children').click(function () {
    $(this).toggleClass('menu-item-has-children--open').find('.sub-menu').slideToggle(200);
  });
  $('.nav__hamburger').click(function () {
    $('.site-header').toggleClass('active');
  });

  // MODAL
  $('.fc-modal, .fc-modal__close').click(function () {
    $('.fc-modal').fadeOut(100);
  });
  $('.fc-modal__body').click(function (e) {
    e.stopPropagation();
  });
  if ($('.fc-modal').length) {
    setTimeout(function () {
      $('.fc-modal').fadeIn(100);
    }, 10000);
  }

  function shouldPrizeCardFlip(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var limit = window.innerHeight * 0.8;
    return elemTop >= 0 && elemTop < limit;
  }

  /**
   * Trigger the Flip Open animation for Prize Card
   * @param el jQuery element. Container of .prizes__image--number that you want to target
   */
  function triggerFlipOpen(el) {
    return (
      el &&
      el.find('.prizes__image--number').animate(
        {
          deg: 91,
        },
        {
          duration: 750,
          step: function (now) {
            $(this).css({
              transform: 'perspective(1400px) rotateY(-' + now + 'deg)',
            });
          },
        }
      )
    );
  }

  // holiday giveaway hero jump link
  $('#hero-holiday-prizes-jump-link').on('click', function (e) {
    if (this.hash !== '') {
      e.preventDefault();
      var hash = this.hash;
      $('html, body').animate(
        {
          scrollTop: $(hash).offset().top,
        },
        800,
        function () {
          window.location.hash = hash;
        }
      );
    }
  });

  /**
   * Trigger the Flip Close animation for Prize Card
   * @param el jQuery element. Container of .prizes__image--number that you want to target
   */
  function triggerFlipClose(el) {
    return (
      el &&
      el.find('.prizes__image--number').animate(
        {
          deg: 0,
        },
        {
          duration: 500,
          step: function (now) {
            $(this).css({
              transform: 'perspective(1400px) rotateY(-' + now + 'deg)',
            });
          },
        }
      )
    );
  }

  // set initial currentPrizeCardOpen state to false on page load and detect whether or not to automatically flip open the currently active prize card depending on scroll position and screen size (we only want auto-open on mobile)
  var isCurrentPrizeCardOpen = false;
  $(window).on('scroll', function () {
    // only run the function on mobile and tablet
    if ($(window).innerWidth() < 960) {
      // create temp variable to store previous state so we don't unnecessarily fire shouldPrizeCardFlip
      var tempIsOpen;
      if (shouldPrizeCardFlip(document.querySelector('.prizes__item--current'))) {
        tempIsOpen = isCurrentPrizeCardOpen;
        isCurrentPrizeCardOpen = true;
      } else {
        tempIsOpen = isCurrentPrizeCardOpen;
        isCurrentPrizeCardOpen = false;
      }
      checkOpen(tempIsOpen, isCurrentPrizeCardOpen);
    }
  });
  /**
   * function to check whether or not to open the currently active prize card
   * @param {boolean} tempIsOpen
   * @param {boolean} isOpen
   */
  function checkOpen(tempIsOpen, isOpen) {
    // if previous open state is the same as current open state, return early because we don't need to trigger any animations....similar to ComponentDidUpdate diff check in React
    if (tempIsOpen === isOpen) return;
    if (isOpen) {
      triggerFlipOpen($('.prizes__item--current'));
    } else {
      triggerFlipClose($('.prizes__item--current'));
    }
  }

  // trigger the flip open animation when hovering on prize card and flip close animation when hovering off
  $('.prizes__item').hover(
    function (e) {
      triggerFlipOpen($(e.target).parent('.prizes__item'));
    },
    function (e) {
      triggerFlipClose($(e.target).parent('.prizes__item'));
    }
  );

  // SLICK for reviews
  $('.slide__wrapper').slick({
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 3,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="22" height="30"><use xlink:href="#svg-arrow_left"/></svg></button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="22" height="30"><use xlink:href="#svg-arrow_right"/></svg></button>',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1,
        },
      },
    ],
  });

  // Level Up Campaign sliders
  if ($('#levelup-carousel')) {
    $('.levelup__carousel__slider--mobile').slick({
      arrows: false,
      dots: true,
      centerMode: true,
      centerPadding: '48px',
      slidesToShow: 1,
    });
    $('.levelup__carousel__slider--tablet').slick({
      arrows: false,
      dots: true,
      centerMode: true,
      centerPadding: '140px',
      slidesToShow: 1,
    });
    $('.levelup__carousel__slider--desktop').slick({
      arrows: false,
      dots: true,
      centerMode: true,
      centerPadding: '300px',
      slidesToShow: 1,
    });
  }
  jQuery.validator.addMethod("phoneUS", function (phone_number, element) {
		phone_number = phone_number.replace(/\s+/g, "");
		return this.optional(element) || phone_number.length > 9 &&
			phone_number.match(/^(1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?\d{3}-?\d{4}$/);
	}, "Please specify a valid phone number");
	
	jQuery.validator.addMethod("postalCodeCA", function (value, element) {
		return this.optional(element) || /^[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]\d$/.test(value);
	}, "Please specify a valid Canadian postal code (e.g., A1A 1A1)");
	
	jQuery.validator.addMethod("strictEmail", function(value, element) {
		return this.optional(element) || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value);
	}, "Please enter a valid email address.");
	
	jQuery.validator.addMethod("lettersOnly", function(value, element) {
		return this.optional(element) || /^[a-zA-Z\s]+$/.test(value);
	}, "Please enter letters only.");
	

  $('#wf-form-Application-Form').validate({
    errorElement: 'span',
    errorClass: 'error',
	rules: {
        email: {
            required: true,
            strictEmail: true
        },
        HomePhone: {
            required: true,
            phoneUS: true
        },
		ReferrerName: {
            required: true,
            lettersOnly: true
        },
		FirstName: {
            required: true,
            lettersOnly: true
        },
		LastName: {
            required: true,
            lettersOnly: true
        },
		PostalCode: {
            required: true,
            postalCodeCA: true
        }
    },
    messages: {
        email: {
            required: "Email is required",
            strictEmail: "Please enter a valid email address"
        },
        HomePhone: {
            required: "Phone number is required",
            phoneUS: "Please enter a valid phone number"
        },
		ReferrerName: {
            required: "Name is required",
            lettersOnly: "Please enter a valid name (letters only)"
        },
		FirstName: {
            required: "Name is required",
            lettersOnly: "Please enter a valid name (letters only)"
        },
		LastName: {
            required: "Name is required",
            lettersOnly: "Please enter a valid name (letters only)"
        },
		PostalCode: {
            required: "Name is required",
            postalCodeCA: "Please enter a valid name (letters only)"
        }
    },
    errorPlacement: function (error, element) {
      error.insertAfter(element.parent('.form-field').find('label'));
    },
    submitHandler: function (form) {
      $('#submitBtn').attr('disabled', true);
      $('#submitBtn').attr('value', 'Please wait...');

      var serialized = $('#wf-form-Application-Form').serialize();

      console.log(serialized);

      $.ajax({
        data: serialized,
        dataType: 'json',
        url: bcs_ajax_object.bcs_ajax_url,
        type: 'POST',
        success: function (data) {
          // if (data.response.Success == true) {
          var url =
            location.protocol +
            '//' +
            window.location.hostname +
            (location.port ? ':' + location.port : '') +
            '/application/success';
          window.location.replace(url);
          // } else {
          //     //console.log('Bad Data');
          //     $('#formerror').show();
          // }
        },
        error: function (data) {
          console.log(data);
          console.error();
        },
      });
    },
  });
  $('#wf-form-Rewards-Application-Form').validate({
    errorElement: 'span',
    errorClass: 'error',
    errorPlacement: function (error, element) {
      error.insertAfter(element.parent('.form-field').find('label'));
    },
    submitHandler: function (form) {
      $.ajax({
        type: 'POST',
        url: $(this).attr('action'),
        ContentType: 'application/json',
        data: $('#wf-form-Rewards-Application-Form').serialize(),
        success: function (data) {
          if (data.response.Success == true) {
            var url =
              location.protocol +
              '//' +
              window.location.hostname +
              (location.port ? ':' + location.port : '') +
              '/rewards-member/thank-you/';
            window.location.replace(url);
          } else {
            console.log('Bad Data');
            $('#formerror').show();
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
  });
});
var formCurrentTab = 0; // Current tab is set to be the first tab (0)
formShowTab(formCurrentTab); // Display the current tab

function setEnter(n) {
  var x = document.getElementsByClassName('tab');
  var y = document.getElementById('wf-form-Application-Form');
  if (n < length.x) {
    y.addEventListener('keydown', function (event) {
      if (event.key == 'Enter' || event.key == 'NumpadEnter') {
        event.preventDefault();
        nextPrev(1);
      }
    });
  } else if (quietValidateForm()) {
    y.addEventListener('keydown', function (event) {
      if (event.key == 'Enter' || event.key == 'NumpadEnter') {
        y.submit();
      }
    });
  }
}
function submitAction() {
  var x = document.getElementById('submitBtn');
  x.disabled = true;
  x.value = 'Please wait...';
}
function formShowTab(n) {
  // This function will display the specified tab of the form ...
  var x = document.getElementsByClassName('tab');
  if (x.length !== 0) {
    x[n].style.display = 'flex';
    // ... and fix the Previous/Next buttons:
    if (n == 0) {
      document.getElementById('prevBtn').style.display = 'none';
      document.getElementById('submitBtn').style.display = 'none';
    } else {
      self.location.href = '#wf-form-Application-Form';
      document.getElementById('prevBtn').style.display = 'inline';
    }
    if (n == x.length - 1) {
      document.getElementById('nextBtn').style.display = 'none';
      document.getElementById('submitBtn').style.display = 'inline';
    } else {
      document.getElementById('nextBtn').style.display = 'inline';
      document.getElementById('submitBtn').style.display = 'none';
    }
  }
  // ... and run a function that displays the correct step indicator:
  // fixStepIndicator(n)
}
function nextPrev(n) {
  // This function will figure out which tab to display
  var x = document.getElementsByClassName('tab');
  // Exit the function if any field in the current tab is invalid:
  if (n == 1 && !multiValidateForm()) return false;
  // Hide the current tab:
  x[formCurrentTab].style.display = 'none';
  // Increase or decrease the current tab by 1:
  formCurrentTab = formCurrentTab + n;
  // if you have reached the end of the form... :
  if (formCurrentTab >= x.length) {
    //...the form gets submitted:
    document.getElementById('wf-form-Application-Form').submit();
    return false;
  }
  // Otherwise, display the correct tab:
  formShowTab(formCurrentTab);
  setEnter(formCurrentTab);
}
function quietValidateForm() {
  var x,
    y,
    i,
    z,
    valid = true;
  x = document.getElementsByClassName('tab');
  y = x[formCurrentTab].getElementsByTagName('input');
  z = x[formCurrentTab].getElementsByTagName('select');
  for (i = 0; i < y.length; i++) {
    if (y[i].value == '') {
      valid = false;
    }
  }
  for (i = 0; i < z.length; i++) {
    if (z[i].value == '') {
      valid = false;
    }
  }
  return valid;
}
function multiValidateForm() {
  // This function deals with validation of the form fields
  var x, y, z, i, valid = true;
  x = document.getElementsByClassName('tab');
  y = x[formCurrentTab].getElementsByTagName('input');
  z = x[formCurrentTab].getElementsByTagName('select');
  // A loop that checks every input field in the current tab:
  for (i = 0; i < y.length; i++) {
    // If a field is empty...
    if (!jQuery(y[i]).valid()) {
      // add an "invalid" class to the field:
      jQuery(y[i]).addClass('error skipped');
      // and set the current valid status to false:
      valid = false;
    }else{
		// Remove error class if valid
		jQuery(y[i]).removeClass('error skipped');
	}
  }
  for (i = 0; i < z.length; i++) {
    if (z[i].value == '') {
      z[i].className += ' error skipped';
      valid = false;
    }
  }
  // If the valid status is true, mark the step as finished and valid:
  if (valid) {
    // document.getElementsByClassName("step")[formCurrentTab].className += " finish";
  }
  return valid; // return the valid status
}
function fixStepIndicator(n) {
  // This function removes the "active" class of all steps...
  var i,
    x = document.getElementsByClassName('step');
  for (i = 0; i < x.length; i++) {
    x[i].className = x[i].className.replace(' active', '');
  }
  //... and adds the "active" class to the current step:
  x[n].className += ' active';
}

////////////////////////
////// COOKIESSS ///////
////////////////////////
setCookie('marketingCampaign', 14);
if (document.URL.indexOf('application') !== -1) {
  if (document.getElementById('AdCampaign')) {
    document.getElementById('AdCampaign').value = readCookie('marketingCampaign');
  }
}

function readURL(name) {
  if (document.URL.indexOf('?') !== -1) {
    var nameEQ = name + '=';
    var ca = document.URL.split('?')[1].split('&');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}
function setCookie(key, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = '; expires=' + date.toGMTString();
  }

  if (readURL(key) != null) {
    document.cookie = key + '=' + readURL(key) + expires + '; path=/';
  } else {
    return null;
  }
}
function readCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}
